import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { connect } from 'react-redux';
import { inputFormatters } from '@blend/ui-common';
import { colors, fonts } from '@blend/consumer-components';

import * as buyingPowerCalculatorForm from 'login-utils/buyingPowerCalculatorForm';

const styles = StyleSheet.create({
  summary: {
    ...fonts.Roboto,
    color: colors.newGrayDark,
    fontSize: 14,
    lineHeight: '1.4em',
    marginRight: 4,
  },
  value: {
    fontWeight: fonts.weight.bold,
    color: colors.newGrayDarker,
  },
});

type BuyingPowerInputSummaryStateProps = buyingPowerCalculatorForm.FIELDS;

export class BuyingPowerInputSummary extends React.Component<BuyingPowerInputSummaryStateProps, {}> {
  getFormattedValue = (value: string, type?: 'money' | 'percentage' | 'number') => {
    if (type === 'money') {
      return inputFormatters.MONEY.formatRoundedWithDollarSign(value);
    }
    if (type === 'percentage') {
      return inputFormatters.PERCENTAGE.format(value);
    }
    if (type === 'number') {
      return inputFormatters.NUMBER.format(value);
    }
    return value;
  };

  getValueSpan = (value: string, type?: 'money' | 'percentage' | 'number') => {
    return <span className={css(styles.value)}>{this.getFormattedValue(value, type)}</span>;
  };

  render() {
    const { totalAssets, creditScore, monthlyIncome, monthlyDebt, downPayment, interestRate, county } = this.props;
    return (
      <div className={css(styles.summary)}>
        Buying power for credit score of {this.getValueSpan(creditScore, 'number')} with{' '}
        {this.getValueSpan(totalAssets, 'money')} total assets, {this.getValueSpan(monthlyIncome, 'money')} monthly
        income, and {this.getValueSpan(monthlyDebt, 'money')} monthly debt at a{' '}
        {this.getValueSpan(interestRate, 'percentage')} interest rate in {this.getValueSpan(county.countyName)}.{' '}
        {downPayment && <span>Down payment preset to {this.getValueSpan(downPayment, 'money')}.</span>}
      </div>
    );
  }
}

const mapStateToProps = state => buyingPowerCalculatorForm.getFormValues(state) as BuyingPowerInputSummaryStateProps;

export default connect<BuyingPowerInputSummaryStateProps, {}, {}>(mapStateToProps)(BuyingPowerInputSummary);
